import BluePlusIcon from "../../assets/images/icons/BluePlusIcon.svg"

import ModalComponent from "../Modal/Modal"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { showSnackBar } from "../Snackbar/Snackbar"
import { areFieldsNotEmpty } from "../../helpers/helper"
import Dropdown from "../Dropdown/Dropdown"
import UploadContainer from "../UploadContainer/UploadContainer"
import Input from "../Input/Input"
import { createDocument } from "../../features/documents/documents"
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider"
import { getPublicIP } from "../../utils/ip"
import { Autocomplete, TextField } from "@mui/material"

const DOCUMENT_TYPES = ".pdf, .docx, .doc, .png, .jpeg, .jpg"

const UploadNewDocumentModal = ({ userId, setIsUpdate, isUpdate, dropdownData, existingSubfolders = [], canUploadAudio = false }) => {
  const acceptedTypes = canUploadAudio ? `${DOCUMENT_TYPES}, .mp3` : DOCUMENT_TYPES

  const dispatch = useDispatch()
  const [reqError, setReqError] = useState('')
  const { triggerLoading } = useMyContextLoading()
  const [publicIP, setPublicIP] = useState("Loading...")

  useEffect(() => {
    getPublicIP().then(setPublicIP)
  }, [])

  const [closeModalOnSubmit, setCloseModalOnSubmit] = useState(true)
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    file: '',
    subfolder: ''
  })
  const resetFormData = () => {
    setFormData(
      {
        name: '',
        type: '',
        file: '',
        subfolder: ''
      }
    )
  }
  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError])

  const handleInputChange = ({ name, value }) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }))
  }


  const uploadDocument = async () => {
    triggerLoading(true)
    const response = await dispatch(createDocument({
      body: formData,
      type: dropdownData.find((type) => type.value === formData.type),
      fileType: formData?.file?.type.split("/")[1], userId,
      ip: publicIP
    }))
    setIsUpdate(!isUpdate)
    if (response.error) {
      setReqError(response.payload)
    } else {
      showSnackBar("success", "The document is successfully uploaded")
    }
    triggerLoading(false)
  }


  return (
    <ModalComponent iconButton={BluePlusIcon} buttonTitle='Upload Documents' modalButtonTitle="Submit"
      title="Upload Documents" functionButton={uploadDocument}
      disabled={!areFieldsNotEmpty([formData.type, formData?.file?.name])}
      onClose={resetFormData} buttonType="outlined"
      buttonClasses="border mr-[10px] !border-primary-main h-10 text-md"
      closeOnSubmit={closeModalOnSubmit}>
      <div className="max-w-[630px]">
        <div className="grid mb-6 h-100">
          <Input placeholder={"File Name"}
            label='Name This File'
            value={formData.name}
            onChange={(e) => handleInputChange({ name: 'name', value: e.target.value })}
            parentClassName='mb-6'
            classes='h-[56px]'
          />
          <Dropdown
            setValue={(val) => handleInputChange({ name: 'type', value: val })} value={formData.type}
            menuItems={dropdownData}
            variant='standard' label="Document Type" />
          <Autocomplete
            freeSolo
            options={existingSubfolders}
            value={formData.subfolder}
            onChange={(e, newValue) => handleInputChange({ name: 'subfolder', value: newValue || '' })}
            onInputChange={(e, newValue) => handleInputChange({ name: 'subfolder', value: newValue || '' })}
            renderInput={(params) => (
              <TextField {...params} label="Subfolder (optional)" variant="standard" sx={{ mt: 2 }} />
            )}
          />
          <UploadContainer
            backFile={(file) => handleInputChange({ name: 'file', value: file })}
            className='mt-6' typeFiles={acceptedTypes} title="Select a File" titleTypeFiles={acceptedTypes} />
        </div>
      </div>
    </ModalComponent>
  )
}
export default UploadNewDocumentModal
